import styled from 'styled-components';

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInputField = styled.input`
  width: 100%;
  padding: 10px 40px 10px 16px;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.clearGray};
  font-size: 14px;
  color: ${props => props.theme.colors.darkBlue};
  outline: none;
  transition: border-color 0.3s;
  height: ${props => props.height || 'auto'};

  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }

  &::placeholder {
    color: ${props => props.theme.colors.clearGray};
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.clearGray};
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`; 